
    import {Component, Vue} from 'vue-property-decorator'
    import bmryDetail from './bmry-Detail.vue'
    // import AddOrUpdate2 from './credentials-user-add'
    import AddOrUpdate2 from './bmry-add'
    import bmryAdd from './bmry-add'
    import Template from "@/template.vue";
    import ImgShow from './img-show'
    import bmryMs from './bmryMs-update.vue'
    // import Template from "@/template.vue";
    // import fa from "element-ui/src/locale/lang/fa";
    @Component({
        name: 'contractinfo',
        components: {
            Template,
            bmryDetail,
            AddOrUpdate2,
            ImgShow,
            bmryAdd,
            bmryMs
        }
    })
    export default class contractinfo extends Vue {
        customerVisible = false
        customerVisible2 = false
        showAddBmry = false
        currentNo: number = 1;
        pageSize: number = 10;
        pageTotal: number = 0;
        activeNames = [];
        credentials = [];
        showbmxxVisible: boolean = false;
        customerList = []
        showfileVisible = false
        showInfoVisible = false
        open = false
        isUploading = false
        // 用户导入参数
        upload = {
            // 弹出层标题（用户导入）
            title: '',
            // 是否更新已经存在的用户数据
            updateSupport: 0,
            // 设置上传的请求头部
            // headers: {
            //   Authorization: 'Bearer '+`${store.getters.token}`
            // },
            // 上传的地址
            // url: this.$request.defaults.baseURL + '/syrkquery/hsdj/importData?access_token='+this.$store.getters.token
        }
        searchForm = {
            xm: '',
            sjhm: '',
            zjhm: '',
            zt: ''
        }
        startTime = []
        endTime = []
        amount = ['', '']
        contractList = []
        loading: boolean = false;
        dataListSelections = [];
        sjbm = []
        selectBm = ''
        filesShow=false
        filesData=[]
        setUsetVisible=false

        setUserChange(user){
            debugger
        }

        setUser(row) {
            this.setUsetVisible = true
            // this.$refs.xzry.init(row.id)
            this.$nextTick(() => {
                this.$refs.xzry.init(row.id)
            })
        }

        //面试结果
        setResult(){

        }
        cancelFileShow(){
            this.filesShow=false
        }

        // 文件上传中处理
        handleFileUploadProgress(event, file, fileList) {
            this.isUploading = true
        }

        // 文件上传成功处理
        handleFileSuccess(response, file, fileList) {
            this.open = false
            this.isUploading = false
            this.$refs.upload.clearFiles()
            debugger
            this.$alert(response.message, '导入结果', {dangerouslyUseHTMLString: true})
            this.searchData()
        }

        // 提交上传文件
        submitFileForm() {
            this.$refs.upload.submit()
        }

        /** 下载模板操作 */
        importTemplate() {
            this.downBlobFile(this.$request.defaults.baseURL + '/bjba/bmry/getTemplate?access_token=' + this.$store.getters.token, {}, `bmry.xlsx`)
        }

        activated() {
            this.searchData();
        }

        created() {
            this.searchData();
            this.getCredentials()
        }

        handleSizeChange(val: number) {
            this.pageSize = val;
            this.searchData();
        }

        handleCurrentChange(val: number) {
            this.currentNo = val;
            this.searchData();
        }

        exportExcel() {
            this.$refs.exportForm.submit();
        }

        getTemplate() {
            this.$refs.getTemplateForm.submit();
        }

        /** 导入按钮操作 */
        handleImport() {
            debugger
            // this.upload.title = '非标准地址导入'
            this.open = true
        }

        preview(row) {
            // var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview/'+id+'?type=1&access_token='+this.$store.getters.token
            // window.open(viewUrl)
            debugger
            let files = JSON.parse(row.filesstr);
            if(files){
                let fileResult = []
                for (let i=0;i<files.length;i++){
                    let file = {name:files[i].url.slice(files[i].url.lastIndexOf("/") + 1),url:files[i].url}
                    fileResult.push(file)
                }
                this.filesData = fileResult;
                this.filesShow = true
            }

            // this.$nextTick(() => {
            //     this.$refs.showfile.init(row.id, 1)
            // })
        }

        showInfo(row) {

            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showinfo.init(row.id)
            })
        }

        getCredentials() {
            let that = this;
            this.$request.get('/bjba/credentials/findAll').then(res => {
                this.credentials = res.data.data
            })
        }

        changeInex() {
            this.currentNo = 1
        }

        searchData() {
            // if (this.startTime && this.startTime.length == 2) {
            //     this.searchForm.startTimest = this.startTime[0]
            //     this.searchForm.startTimeed = this.startTime[1]
            // } else {
            //     this.searchForm.startTimest = ''
            //     this.searchForm.startTimeed = ''
            // }
            this.searchForm.page = this.currentNo
            this.searchForm.pagesize = this.pageSize
            this.loading = true;
            this.$request({
                url: '/bjba/bmryMsry/page',
                method: 'get',
                params: this.searchForm
            })
                .then(response => {
                    this.loading = false;
                    console.log(response);
                    let data = response.data;
                    if (data.code == 200) {
                        this.contractList = data.data.data;
                        this.pageTotal = data.data.count
                    } else {
                        this.$message.error(data.message)
                    }
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error)
                    this.$message.error(error)
                });
        }

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        }


        addOrUpdate(val: any) {
            debugger
            if (val) {
                this.customerVisible = true
                this.$nextTick(() => {
                    this.$refs.customer.init(val)
                })
            } else {
                this.showAddBmry = true
                this.$nextTick(() => {
                    this.$refs.customer2.init(val)
                })
            }

        }

        deleteHandle(id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            if (!ids || ids.length == 0) return
            this.$confirm(`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: `/bjba/bmry/delete`,
                    method: 'post',
                    data: ids
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if (data && data.code == 500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }

        getAge(iden: String) {
            let val = iden.length;
            let myDate = new Date();
            let month = myDate.getMonth() + 1;
            let day = myDate.getDate();
            let age = 0;
        
            if (val === 18) {
                age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        
                if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;
        
            }
            if (val === 15) {
                age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
        
                if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
            }
        
            return age;
        
        }
    }
